import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { DeleteSvg } from './svgs';

export const IconDelete: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={DeleteSvg} viewBox="0 0 24 24" {...props} />;
};
